<template>
  <v-card
    class="mx-0 px-0 mb-5"
    outlined
  >
    <v-alert v-if="erros" type="error">
      {{ erros }}
    </v-alert>

    <v-form
      v-show="!erros && !loading"
      ref="formPgto"
      class="mx-3 pt-0 mt-0"
    >
      <v-row>
        <v-col
          class="mx-0 px-0 pt-0 mt-0"
          cols="12"
        >
          <v-alert type="success">
            Pagamentos Processo
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="pt-0 mt-0"
          cols="12"
          md="6"
          v-if="obrigaIndenizacao"
        >
          <v-menu
            v-model="menuDataIndenizacao"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dataPagamentoIndenFormatada"
                :error-messages="validacaoForm($v.formPagto.dt_pgtoindeniz, 'Data Pgto Indenização')"
                label="Data Pgto Indenização"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
                autocomplete="nope"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="$v.formPagto.dt_pgtoindeniz.$model" 
              no-title 
              @input="menuDataIndenizacao = false"
              ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          class="pt-0 mt-0"
          cols="12"
          md="6"
          v-if="obrigaIndenizacao"
        >
          <VuetifyMoney
            v-model="$v.formPagto.vl_pgtoindeniz.$model"
            :errorMessages="validacaoForm($v.formPagto.vl_pgtoindeniz, 'Vlr Indenização')"
            v-bind:label="'Valor Indenização'"
            autocomplete="nope"
          />  
        </v-col>
        <v-col
          class="pt-0 mt-0"
          cols="12"
          md="6"
          v-if="mostrarPgtoHonorario"
        >
          <v-menu
            v-model="menuData"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :disabled="!permiteUpdVL_PAGO"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dataPagamentoFormatada"
                :error-messages="validacaoForm($v.formPagto.dt_pagamento, 'Data Pgto Honorários')"
                label="Data Pgto Honorários"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
                autocomplete="nope"
                :disabled="!permiteUpdVL_PAGO"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="$v.formPagto.dt_pagamento.$model" 
              no-title 
              @input="menuData = false"
              :disabled="!permiteUpdVL_PAGO"
              ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          class="pt-0 mt-0"
          cols="12"
          md="6"
          v-if="mostrarPgtoHonorario"
        >
          <VuetifyMoney
            :disabled="!permiteUpdVL_PAGO"
            v-model="$v.formPagto.vl_pago.$model"
            :errorMessages="validacaoForm($v.formPagto.vl_pago, 'Valor Honorários')"
            v-bind:label="'Valor Honorários'"
            autocomplete="nope"
          />  
        </v-col>
      </v-row>

    </v-form>
  </v-card>
</template>
<script>


import validacaoForm from '@/mixins/validacaoForm'
import {requiredIf} from 'vuelidate/lib/validators'
import apiClient from '@/plugins/axios'
import VuetifyMoney from "@/components/Inputs/VuetifyMoney.vue";
import validaProcesso from '@/utils/validaProcesso'
import privilegiosUsuario from "@/utils/privilegiosUsuario"


export default {
  name: 'PagamentoHonorarios',
  mixins:[validacaoForm],
  props: ['processo_id', 'status'],
  components: {VuetifyMoney},
  data() {
    return {
      menuData: false,
      menuDataIndenizacao: false,
      erros: null,
      mostrarPgtoHonorario: false,
      formPagto: {
        id: '',
        dt_pgtoindeniz: '',
        vl_pgtoindeniz: '',
        dt_pagamento: '',
        vl_pago: '',
        processo_id: '',
      },
      isObrigaIndenizacao: false,
      loading: false,
      permiteUpdVL_PAGO: false
    }
  },
  validations: {
    formPagto: {
      dt_pagamento: { 
        required: requiredIf(function(item) {
          return this.status == validaProcesso.status.PAGO_HONORARIOS || this.status == validaProcesso.status.ARQUIVO ? true : false 
        }),
        errors: [] 
      },
      vl_pago: { required: requiredIf(function(item) {
          return this.status == validaProcesso.status.PAGO_HONORARIOS || this.status == validaProcesso.status.ARQUIVO ? true : false
        }), 
        errors: []
      },
      dt_pgtoindeniz: { 
        required: requiredIf(function(item) {
          return this.isObrigaIndenizacao
        }),
        errors: [] 
      },
      vl_pgtoindeniz: { 
        required: requiredIf(function(item) {
          return this.isObrigaIndenizacao
        }),
        errors: [] 
      },
    }
  },
  async created() {
    this.isObrigaIndenizacao = true
    this.habilitaCampos()
    await this.buscarPagamento()
  },
  watch: {
    async processo_id(newVal) {
      await this.buscarPagamento()
      this.$v.formPagto.$reset()
    },
    formPagto(newVal) {
      this.permissionFieldVlPago()
    },
    status(newVal) {
      this.habilitaCampos()
    }
  },
  methods: {
    habilitaCampos() {
      this.mostrarPgtoHonorario = false
      if (this.status == validaProcesso.status.PAGO_HONORARIOS) this.mostrarPgtoHonorario = true
      if (this.status == validaProcesso.status.ARQUIVO) this.mostrarPgtoHonorario = true
    },
    async gravar() {
      if (!(await this.validaForm())) {
        return false
      }
      return {
        id: this.formPagto.id,
        dt_pagamento: this.formPagto.dt_pagamento, 
        vl_pago: this.formPagto.vl_pago,
        dt_lancamento: this.$moment().format('YYYY-MM-DD'), 
        vl_receber: this.formPagto.vl_pago,
        dt_pgtoindeniz: this.formPagto.dt_pgtoindeniz,
        vl_pgtoindeniz: this.formPagto.vl_pgtoindeniz
      }
    },
    async validaForm () {
      this.$v.formPagto.$touch();
      if (!this.$v.formPagto.$invalid) {
        return true
      } else if (this.$v.formPagto.$anyError) {
        return false
      }
    },
    buscarPagamento() {
      this.isObrigaIndenizacao = true
      if (!this.processo_id > 0) return
      this.loading = true
      this.erros = null
      this.formPagto = {
        id: '',
        dt_pagamento: '',
        vl_pago: '',
        processo_id: '',
        dt_pgtoindeniz: '',
        vl_pgtoindeniz: ''
      }
      apiClient.get(`pagamento/${this.processo_id}`)
      .then(response => {
        if (response.data.status) {
          if (response.data.pagamento) {
            this.formPagto = response.data.pagamento
            if (!this.formPagto.dt_pgtoindeniz) this.isObrigaIndenizacao = false
          }
        } else if (response.data.erro) {
          this.erros = response.data.erro
        }
      })
      .catch(error => {
        this.erros = "Erro ao buscar pagamento do processo. Tente Novamente".
        console.log(error)
      })
      .finally(() => this.loading = false)
    },
    permissionFieldVlPago() {
      this.permiteUpdVL_PAGO = true
      if (!privilegiosUsuario.permitirAlterarPagamentoProcesso() && this.formPagto.vl_pago !== null) this.permiteUpdVL_PAGO = false
    }
  },
  computed: {
    dataPagamentoFormatada: {
      get: function() {
        if (!this.formPagto.dt_pagamento) return this.formPagto.dt_pagamento
        return this.$moment(this.formPagto.dt_pagamento, 'YYYY-MM-DD').format('DD-MM-YYYY')
      },
      set: function(newVal){
        this.formPagto.dt_pagamento = newVal
      }
    },
    dataPagamentoIndenFormatada: {
      get: function() {
        if (!this.formPagto.dt_pgtoindeniz) return this.formPagto.dt_pgtoindeniz
        return this.$moment(this.formPagto.dt_pgtoindeniz, 'YYYY-MM-DD').format('DD-MM-YYYY')
      },
      set: function(newVal){
        this.formPagto.dt_pgtoindeniz = newVal
      }
    },
    obrigaIndenizacao() {
      return this.isObrigaIndenizacao ? true : false
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/views/Processo/PagamentoHonorarios.vue